import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import user from "../../../../Assets/images/user.png";
import doc from "../../../../Assets/images/doc.png";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import // ADD_DRIVER,
  // EDIT_DRIVER,
  // GET_DRIVER_BY_ID,
  "../../../../services/ApiCalls";
import { toast } from "react-toastify";
// import { createObjectURL } from "../../../../utilities/utilities";
import fileUploader from "../../../../utilities/fileUploader";
import { Link, useNavigate, useParams } from "react-router-dom";
import { catchAsync, checkResponse } from "../../../../utilities/utilies";
import {
  ADD_DRIVER,
  GET_DRIVER_BY_ID,
  UPDATE_DRIVER,
  GET_SERVICES_TYPES
} from "../../../../services/ApiCalls";
import Select from "react-select";
import AddressInput from "../../../../components/Common/address";


const AddDriver = () => {
  const options = [
    { value: "agency", label: "Agency" },
    { value: "individual", label: "Individual" },
  ];
  const [selectedOption, setSelectedOption] = useState(null);
  // const [showInput, setShowInput] = useState(false);

  const handleChange = (option) => {
    setSelectedOption(option);
    // setShowInput(option && option.value);
    setValue("type", option.value);
  };

  const { id } = useParams();
  const schema = z.object({
    name: z.string().trim().min(1, { message: " name is required" }),
    email: z
      .string({
        required_error: "Email is required",
      })
      .min(1, { message: "Email is required" })
      .email("Invalid email address"),
    address: z.string().trim().min(1, { message: "Address is required" }),
    ...(!id && {
      password: z.string().min(1, { message: "Password is required" }),
    }),
    // bank details
    routingNumber: z
      .string()
      .trim()
      .min(1, { message: "Routing Number is required" }),
    accountNumber: z
      .string({
        required_error: "Account Number is required",
      })
      .min(1, { message: "Account Number is required" })
      .refine((data) => !isNaN(data), {
        message: "Account Number only contain a Numeric value",
      }),

    accountHolderName: z
      .string()
      .trim()
      .min(1, { message: "Account HolderName  is required" }),
    bankName: z.string().trim().min(1, { message: "Bank Name   is required" }),
    vehiclePlateNumber: z
      .string()
      .trim()
      .min(1, { message: "vehicle Plate Number Number is required" }),
    vehicleMake: z
      .string()
      .trim()
      .min(1, { message: "vehicle Make  is required" }),
    vehicleModel: z
      .string()
      .trim()
      .min(1, { message: "vehicle Model is required" }),
    vehicleColor: z
      .string()
      .trim()
      .min(1, { message: "vehicle Color is required" }),
    type: z.string().min(1, { message: "Driver Type is required" }),
  });

  const [contactNumber, setContactNUmber] = useState({
    countryCode: "",
    mobileNumber: "",
  });
  const [Error, setError] = useState({
    contactNumber: "",
  });

  const [driverDetail, setDriverDetail] = useState();
  const navigate = useNavigate();
  const [documentImages, setDocumentImages] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [allServices, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState([]);
  const [defaultServiceType, setDefaultServiceType] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    values: {
      name: driverDetail?.providerDetails?.name || "",
      email: driverDetail?.providerDetails?.email || "",
      address: driverDetail?.providerDetails?.address || "",
      password: "",
      routingNumber:
        driverDetail?.providerDetails?.accountDetails?.[0]?.routingNumber || "",
      accountNumber:
        driverDetail?.providerDetails?.accountDetails?.[0]?.accountNumber || "",
      accountHolderName:
        driverDetail?.providerDetails?.accountDetails?.[0]?.accountHolderName ||
        "",
      bankName:
        driverDetail?.providerDetails?.accountDetails?.[0]?.bankName || "",
      vehiclePlateNumber: driverDetail?.vehicleDetails?.plateNumber || "",
      vehicleMake: driverDetail?.vehicleDetails?.make || "",
      vehicleModel: driverDetail?.vehicleDetails?.model || "",
      vehicleColor: driverDetail?.vehicleDetails?.color || "",
      type: driverDetail?.providerDetails?.type || "",
      services:
        driverDetail?.vehicleDetails?.services?.map((service) => service.id) || [],
    },
  });

  const imageChangeHandler = async (e, type) => {
    const url = await fileUploader(e.target.files[0]);
    if (!url) {
      return;
    }
    if (type === "document") {
      setDocumentImages((p) => {
        return [url];
      });
    }
    if (type === "profile") {
      setProfileImage((p) => url);
    }
  };

  const editHandler = catchAsync(async (data) => {
    const res = await UPDATE_DRIVER({
      driverId: id,
      ...data,
      profileImage,
      ...contactNumber,
      documentsList: documentImages?.map((item) => ({ image: item })),
      vehicleDetails: {
        _id: driverDetail?.vehicleDetails?._id,
        make: data?.vehicleMake,
        color: data.vehicleColor,
        plateNumber: data.vehiclePlateNumber,
        model: data.vehicleModel,
        services: driverDetail?.vehicleDetails?.services?.map((service) => service.id) || [],

      },
      accountDetails: {
        _id: driverDetail?.providerDetails?.accountDetails?.[0]?._id,
        routingNumber: data.routingNumber,
        accountNumber: data.accountNumber,
        accountHolderName: data.accountHolderName,
        bankName: data.bankName,
      },
      type: data.type,
    });
    const success = checkResponse({ res, showSuccess: true });

    if (success) navigate("/manage-driver/registered-driver");
  });

  const submitHandler = catchAsync(async (data) => {
    if (
      !contactNumber.countryCode.trim() ||
      !contactNumber.mobileNumber.trim()
    ) {
      return setError((p) => ({
        ...p,
        contactNumber: "Phone Number is Required",
      }));
    } else {
      setError((p) => ({ ...p, contactNumber: "" }));
    }

    if (!profileImage) {
      return toast.error("please add the profile image");
    }

    if (documentImages.length === 0) {
      return toast.error("please add the documents image");
    }

    if (selectedService.length === 0) {
      return toast.error("please add the service ");
    }

    if (id) {
      return editHandler({ ...data });
    }

    const res = await ADD_DRIVER({
      ...data,
      profileImage,
      selectedServices: selectedService,
      documentsList: documentImages?.map((item) => ({ image: item })),
      ...contactNumber,
    });
    const success = checkResponse({ res, showSuccess: true });

    if (success) navigate("/manage-driver/registered-driver");
  });

  const getDriver = catchAsync(async () => {
    const res = await GET_DRIVER_BY_ID(id);

    const success = checkResponse({ res });


    if (success) {
      setDriverDetail(res?.data?.data);
      setProfileImage(res?.data?.data?.providerDetails?.profileImage);
      setDefaultServiceType(res?.data?.data?.providerDetails?.serviceType);
      setDocumentImages(
        res?.data?.data?.providerDetails?.documentsList?.map(
          (item) => item.image
        )
      );
      setContactNUmber({
        mobileNumber: res?.data?.data?.providerDetails?.mobileNumber,
        countryCode: res?.data?.data?.providerDetails?.countryCode,
      });
      setSelectedOption({
        value: res?.data?.data?.providerDetails?.type,
        label: res?.data?.data?.providerDetails?.type,
      });
    }
  });

  const handleServiceSelect = async (option) => {
    let type = option.type;
    try {
      const res = await GET_SERVICES_TYPES({ type });
      if (res.data.status === "success") {
        setServices(
          res.data?.data?.map((item) => {
            const additionalFields = (
              <div className="d-flex justify-content-between">
                <img
                  src={item.image}
                  alt={item.name}
                  style={{ width: "30px", height: "30px" }}
                />
                <span>{item.name}</span>
                <span style={{ color: "gray" }}>{item.weightCapacity}(lb)</span>
              </div>
            );
            return {
              id: item._id,
              image: item.image,
              weightCapacity: item.weightCapacity,
              label: additionalFields,
              labelValue: item.name,
              value: item.type
            };
          })
        );
      } else {
        console.error("Failed to fetch serviceType details", res.error);
      }
    } catch (error) {
      console.error("Error fetching serviceType details:", error);
    }
  };

  console.log(documentImages, "sddf");

  useEffect(() => {
    if (id) getDriver(id);
  }, [id]);

  return (
    <section className="AddService py-3">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12" className="my-2">
            <Link to="/manage-driver/registered-driver" className="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="41"
                height="41"
                viewBox="0 0 41 41"
                fill="none"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="40"
                  height="40"
                  rx="11.5"
                  fill="white"
                  stroke="#D9DADC"
                />
                <path
                  d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                  fill="#1E232C"
                  stroke="#1E232C"
                  stroke-width="0.2"
                />
              </svg>
            </Link>
          </Col>
          <Col lg="9" className="my-2">
            <div className="formWrpper px-sm-4 box p-3 pb-5">
              <Form onSubmit={handleSubmit(submitHandler)}>
                <Row className="justify-content-center">
                  <Col md="6" className="my-2">
                    <div className="py-2">
                      <div className="py-2 head">
                        <h6 className="m-0 fw-bold">Personal Details</h6>
                      </div>
                      <div className="py-2">
                        <div
                          className={` d-flex gap-10 align-items-start position-relative`}
                        >
                          <div className="left position-relative">
                            <div
                              className={` imgWrp mx-auto rounded-circle`}
                              style={{
                                background: "rgb(243, 243, 243)",
                                height: 100,
                                width: 100,
                                aspectRatio: 1,
                              }}
                            >
                              <input
                                type="file"
                                className="file position-absolute h-100 w-100"
                                onChange={(e) =>
                                  imageChangeHandler(e, "profile")
                                }
                              />
                              <img
                                src={profileImage || user}
                                alt=""
                                className="img-fluid w-100 h-100 rounded-circle"
                              />
                              <span
                                className="icn position-absolute"
                                style={{ right: 0, bottom: 0 }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="36"
                                  height="36"
                                  viewBox="0 0 36 36"
                                  fill="none"
                                >
                                  <circle
                                    cx="18"
                                    cy="18"
                                    r="18"
                                    fill="#C11111"
                                  />
                                  <g clip-path="url(#clip0_14_237)">
                                    <path
                                      d="M15.4568 25.098C15.2648 25.098 15.0728 25.0245 14.9265 24.8783L11.1218 21.0735C10.8285 20.7803 10.8285 20.3063 11.1218 20.013L19.9995 11.136C20.2928 10.8428 20.7668 10.8428 21.06 11.136L24.8648 14.9408C25.158 15.234 25.158 15.708 24.8648 16.0013L15.987 24.8783C15.8408 25.0245 15.6488 25.098 15.4568 25.098ZM12.7125 20.5433L15.4568 23.2875L23.2733 15.4703L20.529 12.726L12.7125 20.5433Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M9.74996 27C9.55421 27 9.36221 26.9235 9.21971 26.7803C9.01871 26.5793 8.94896 26.2823 9.03821 26.013L10.9402 20.3063C11.0227 20.0595 11.2267 19.8735 11.4795 19.8135C11.7322 19.7543 11.9985 19.8293 12.1822 20.013L15.987 23.8178C16.1707 24.0015 16.2465 24.2678 16.1865 24.5205C16.1265 24.7733 15.9405 24.9773 15.6937 25.0598L9.98696 26.9618C9.90896 26.9873 9.82946 27 9.74996 27ZM11.9797 21.9315L10.9357 25.0643L14.0685 24.0203L11.9797 21.9315Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M24.3337 16.2202C24.1417 16.2202 23.9497 16.1467 23.8035 16.0005L19.9987 12.1957C19.7055 11.9025 19.7055 11.4285 19.9987 11.1352L21.4762 9.65775C22.3522 8.781 23.7787 8.781 24.6547 9.65775L26.3415 11.3445C27.2175 12.2205 27.2175 13.647 26.3415 14.523L24.864 16.0005C24.7177 16.1475 24.5257 16.2202 24.3337 16.2202ZM21.5902 11.6662L24.3345 14.4105L25.2817 13.4632C25.5735 13.1715 25.5735 12.6975 25.2817 12.4057L23.595 10.719C23.3032 10.4272 22.8292 10.4272 22.5375 10.719L21.5902 11.6662Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_14_237">
                                      <rect
                                        width="18"
                                        height="18"
                                        fill="white"
                                        transform="translate(9 9)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                            </div>
                          </div>
                          <div className="right mt-4">
                            <h6 className="m-0 fw-bold">Upload Image</h6>
                          </div>
                        </div>
                      </div>
                      <Col lg="12" className="my-2">
                        <Row>
                          <Col lg="12" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label m-0 fw-sbold text-muted ps-2"
                            >
                              Driver Type
                            </label>
                            <Select
                              options={options}
                              value={selectedOption}
                              onChange={handleChange}
                            />
                            <input
                              type="hidden"
                              {...register("type")}
                              value={selectedOption ? selectedOption.value : ""}
                            />
                            <p className="errorColor">
                              {errors?.type && errors.type.message}
                            </p>
                          </Col>
                          {/* {showInput && (
                            <Col lg="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label m-0 fw-sbold text-muted ps-2"
                              >
                                Additional Information
                              </label>
                              <input
                                type="text"
                                placeholder="Enter something"
                                className="form-control"
                              />
                            </Col>
                          )} */}
                        </Row>
                      </Col>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Jane Cooper"
                          className="form-control ps-3"
                          {...register("name")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.name && errors.name.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <PhoneInput
                          value={`${contactNumber.countryCode}Code, "+" + ${contactNumber.mobileNumber}`}
                          onChange={(mobileNumber, { dialCode }) => {
                            setContactNUmber((p) => ({
                              countryCode: `+${dialCode}`,
                              mobileNumber: mobileNumber.replace(dialCode, ""),
                            }));
                          }}
                        />
                        {
                          <p className="errorColor">
                            {Error?.contactNumber && Error.contactNumber}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        {/* <input
                          type="text"
                          placeholder="Enter Address"
                          className="form-control ps-3"
                          {...register("address")}
                        /> */}
                        <AddressInput
                          name="address"
                          placeholder="Enter Address"
                          errorLabel="Address"
                          required
                          defaultValue=""
                          setValue={(val) => setValue("address", val)}
                          trigger={() => trigger("address")}
                          value={watch("address")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.address && errors.address.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="email"
                          placeholder="Enter Email Address"
                          className="form-control ps-3"
                          {...register("email")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.email && errors.email.message}
                          </p>
                        }
                      </div>
                      {!id && (
                        <div className="py-2">
                          <input
                            type="password"
                            placeholder="Enter Password"
                            className="form-control ps-3"
                            {...register("password")}
                          />
                          {
                            <p className="errorColor">
                              {errors?.password && errors.password.message}
                            </p>
                          }
                        </div>
                      )}
                    </div>
                    <div className="py-2">
                      <div className="py-2 head">
                        <h4 className="m-0 themeBlue fw-bold">Document</h4>
                      </div>
                      <div className="py-2">
                        <div className="upload text-center px-3 position-relative py-4 rounded bg-white border d-flex align-items-center justify-content-center gap-10">
                          <input
                            type="file"
                            placeholder="Name"
                            className="file position-absolute h-100 w-100 ps-3"
                            onChange={(e) => imageChangeHandler(e, "document")}
                          />
                          <div className="document">
                            {documentImages?.map((images) => (
                              <img
                                src={images || doc}
                                alt=""
                                className="img-fluid"
                                style={{
                                  marginRight: "10px",
                                  marginBottom: "10px",
                                  height: "100px",
                                  maxWidth: "50%",
                                }}
                              />
                            ))}
                          </div>
                          <div className="content">
                            <div className="icn mb-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="49"
                                height="45"
                                viewBox="0 0 49 45"
                                fill="none"
                              >
                                <path
                                  d="M38.4649 12.2223C36.7614 3.94371 28.6692 -1.3864 20.3906 0.3171C13.3018 1.77583 8.20417 8.00092 8.17165 15.2381C8.17165 15.5829 8.1859 15.9359 8.21651 16.3093C3.17344 16.8431 -0.48205 21.3641 0.0517639 26.4071C0.546553 31.0815 4.49138 34.6274 9.19184 34.6229H10.2631C10.2386 34.2842 10.2121 33.9475 10.2121 33.6026C10.2121 26.2775 16.1503 20.3393 23.4754 20.3393C30.8005 20.3393 36.7386 26.2775 36.7386 33.6026C36.7386 33.9474 36.7121 34.2841 36.6876 34.6229H37.7589C43.9502 34.6398 48.983 29.6344 49 23.443C49.0162 17.5022 44.3951 12.5802 38.4649 12.2223Z"
                                  fill="#BBDEFB"
                                />
                                <path
                                  d="M23.4757 44.8251C29.6738 44.8251 34.6984 39.8006 34.6984 33.6024C34.6984 27.4043 29.6738 22.3797 23.4757 22.3797C17.2775 22.3797 12.2529 27.4043 12.2529 33.6024C12.2529 39.8006 17.2775 44.8251 23.4757 44.8251Z"
                                  fill="#4CAF50"
                                />
                                <path
                                  d="M23.4756 40.7445C22.9121 40.7445 22.4553 40.2876 22.4553 39.7242V27.4812C22.4553 26.9177 22.9121 26.4609 23.4756 26.4609C24.0391 26.4609 24.4959 26.9177 24.4959 27.4812V39.7242C24.4958 40.2876 24.0391 40.7445 23.4756 40.7445Z"
                                  fill="#FAFAFA"
                                />
                                <path
                                  d="M27.5563 32.5821C27.2855 32.5826 27.0256 32.4755 26.834 32.2842L23.4753 28.9235L20.1166 32.2842C19.7113 32.6757 19.0654 32.6644 18.6739 32.2591C18.292 31.8637 18.292 31.2369 18.6739 30.8415L22.7549 26.7605C23.1533 26.3622 23.7991 26.3622 24.1976 26.7605L28.2786 30.8415C28.6764 31.2406 28.6755 31.8866 28.2763 32.2844C28.0852 32.475 27.8263 32.582 27.5563 32.5821Z"
                                  fill="#FAFAFA"
                                />
                              </svg>
                            </div>
                            <p className="m-0 fw-sbold">
                              Upload driver license
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md="6" className="my-2">
                    <div className="py-2">
                      <div className="py-2 head">
                        <h4 className="m-0 themeBlue fw-bold">
                          Add Vehicle Details
                        </h4>
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Vehicle license plate number"
                          className="form-control ps-3"
                          {...register("vehiclePlateNumber")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.vehiclePlateNumber &&
                              errors.vehiclePlateNumber.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Vehicle make"
                          className="form-control ps-3"
                          {...register("vehicleMake")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.vehicleMake && errors.vehicleMake.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Vehicle model"
                          className="form-control ps-3"
                          {...register("vehicleModel")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.vehicleModel &&
                              errors.vehicleModel.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Vehicle color"
                          className="form-control ps-3"
                          {...register("vehicleColor")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.vehicleColor &&
                              errors.vehicleColor.message}
                          </p>
                        }
                      </div>

                      <div className="py-2">
                        <select
                          className="form-control ps-3"
                          value={defaultServiceType}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setDefaultServiceType(selectedValue)
                            handleServiceSelect({ type: selectedValue });
                          }}
                        >
                          <option value="">Select Vehicle Type</option>
                          <option value="PickupDrop">Pickup Drop</option>
                          <option value="Towing">Towing</option>
                        </select>
                      </div>

                      <div className="py-2">
                        <Select
                          {...register("services")}
                          options={allServices}
                          onChange={(e) => {
                            const selectedValue = e.id;
                            setSelectedService([selectedValue])
                          }}
                        >
                        </Select>
                      </div>

                    </div>
                    <div className="py-2">
                      <div className="py-2 head">
                        <h4 className="m-0 themeBlue fw-bold">Bank Details </h4>
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Bank Name"
                          className="form-control ps-3"
                          {...register("bankName")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.bankName && errors.bankName.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Account Number"
                          className="form-control ps-3"
                          {...register("accountNumber")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.accountNumber &&
                              errors.accountNumber.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Routing Number"
                          className="form-control ps-3"
                          {...register("routingNumber")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.routingNumber &&
                              errors.routingNumber.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Account Holder Name"
                          className="form-control ps-3"
                          {...register("accountHolderName")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.accountHolderName &&
                              errors.accountHolderName.message}
                          </p>
                        }
                      </div>


                    </div>
                  </Col>
                  <Row>
                    <Col lg="4" sm="6" className="my-1">
                      <Button
                        className="d-flex align-items-center justify-content-center commonBtn w-100"
                        type="submit"

                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AddDriver;
